export function isEligible(buzz) {
  if (!buzz) {
    return false;
  }

  return ![
    buzz.flags?.sensitive,
    buzz.shouldHideRecircSection
  ].some(x => x);
}
